import MuiCheckbox, { CheckboxProps as MuiCheckboxProps } from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { ReactNode } from 'react';
import { CheckboxChecked, CheckboxIndeterminate, CheckboxUnchecked } from './icons';

export interface CheckboxProps extends MuiCheckboxProps {
  label?: ReactNode;
}

export function Checkbox({ label, ...props }: CheckboxProps) {
  const box = (
    <MuiCheckbox
      checkedIcon={<CheckboxChecked />}
      icon={<CheckboxUnchecked />}
      indeterminateIcon={<CheckboxIndeterminate />}
      {...props}
    />
  );
  if (label === undefined) return box;
  return <FormControlLabel control={box} label={label} />;
}
